import React from 'react'
import Icon, { IconType } from '@bt-react/components/Icon'
import Button from '@bt-react/components/Button'
import styles from './MediaShareTitle.module.scss'
import { MediaShareTitleProps } from './types'

const _BDD_PREFIX = 'talks-media-share-title'

const MediaShareTitle: React.FC<MediaShareTitleProps> = ({
  text = '',
  buttonText = '',
  onButtonClick = () => {}
}) =>
  <div className={styles['media__shared-notification']} data-bdd={_BDD_PREFIX} >
    {
      text !== '' &&
      <div data-bdd={`${_BDD_PREFIX}-name-container`} >
        <Icon
          name={IconType.iconName.user}
          colour={IconType.colour.darkGrey}
          dataBdd={`${_BDD_PREFIX}-icon`}
          className={styles['media__svg']}
        />
        <span className={styles['media__share-message']} data-bdd={`${_BDD_PREFIX}-text`} >{text}</span>
      </div>
    }
    {
      buttonText !== '' &&
      <Button
        color={IconType.colour.default}
        text={buttonText}
        onClick={onButtonClick}
        dataBdd={`${_BDD_PREFIX}-button`}
      />
    }
  </div>

export default MediaShareTitle
